<div
  class="data-table-cell"
  [class]="'data-table-cell--align-' + alignment()"
  [class.data-table-cell--without-padding-left]="withoutPaddingLeft()"
  [class.data-table-cell--hover]="hover()"
  [class.data-table-cell--clickable]="clickable()"
  [class.p-0]="withoutPadding()"
  [class.data-table-cell-padding]="!withoutPadding()"
>
  @if (cellData() || icon()) {
    @if (icon()) {
      <div [class]="'ms-1 me-2 d-flex icon icon--' + icon()"></div>
    }
    @if (cellData()) {
      <ng-container [ngTemplateOutlet]="cellData()"></ng-container>
    }
  } @else {
    {{ 'shared.no_data' | translate }}
  }
</div>
